module.exports = __webpack_public_path__ + "static/media/GoodCard-logo.e1872abb.png";